import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-bulk-upload-dvr-details',
  templateUrl: './bulk-upload-dvr-details.component.html',
  styleUrls: ['./bulk-upload-dvr-details.component.scss']
})
export class BulkUploadDvrDetailsComponent implements OnInit{
  // @ViewChild('UploadFileInput', { static: false }) uploadFileInput: ElementRef;
  fileUploadForm!: FormGroup;
  fileInputLabel!: string;
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(){
    this.fileUploadForm = this.formBuilder.group({
      myfile: ['']
    });
  }

  onFileSelect($event:any){

  }

  onFormSubmit(){

  }


  generateExcel() {
    // this.excelService.generateExcel();
  }

}
